import React from "react";
import PropTypes from "prop-types";
import {GSPSSubmitButtonStyle} from "Components/Common/GSPSSubmitButton.styles";

export const SVPLoadingSubmitButton = ({
    buttonText,
    buttonLoadingText = "Saving...",
    onClick,
    colClassName,
    isLoading = false,
    isDisabled = false,
    isSubmitting = false,
    form,
}) => {
    return <>
        {!isSubmitting ?
            <GSPSSubmitButtonStyle
                className={`${colClassName} cta-btn`}
                disabled={isDisabled}
                type="submit"
                onClick={onClick}
                form={form}
            >
                {buttonText}
                {isLoading &&
                    <div className="spinner-border spinner-border-sm" role="status" />
                }
            </GSPSSubmitButtonStyle> :
            <GSPSSubmitButtonStyle
                className={`${colClassName} cta-btn`}
                form={form}
                type="submit"
                id="loadingBtn"
                disabled={true}
            >
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {buttonLoadingText}
            </GSPSSubmitButtonStyle>
        }
    </>;
};

SVPLoadingSubmitButton.propTypes = {
    buttonText: PropTypes.string.isRequired,
    buttonLoadingText: PropTypes.string,
    controlSize: PropTypes.number,
    onClick: PropTypes.func,
    colClassName: PropTypes.string,
    isLoading: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    isDisabled: PropTypes.bool,
    secondaryBtn: PropTypes.bool,
    form: PropTypes.string,
};
